jQuery(function($)
{
    var $passwordFieldTriggers = $('.js-enter-visible');

    /**
	 * toggle visibiity of given password field
	 * @param {jQuery} $passwordField
	 */
    function initTogglePassword($passwordField)
    {
        if ($passwordField.get(0).type === 'password')
        {
            $passwordField.get(0).type = 'text';
        }
        else
        {
            $passwordField.get(0).type = 'password';
        }
    }

    /**
	 * toggle the passwordfield found next to the clicked password visible option
	 * @param  {jQuery} $passwordFieldTrigger
	 */
    function initPasswordVisibleOption($passwordFieldTrigger)
    {
        $passwordFieldTrigger.on('click', function()
        {
            var $passwordField = $(this).parent().find('.js-password');

            if ($passwordField.length)
            {
                initTogglePassword($passwordField);
            }
        });
    }

    $passwordFieldTriggers.each(function()
    {
        initPasswordVisibleOption($(this));
    });
});




// jQuery(function ($) {
// 	$('.enter-visible').closest('form')
// 		.each(function () {
// 			var
// 				model = {
// 					'enterVisible': false
// 				},
// 				view = {
// 					'$form': $(this),
// 					'$passwordElements': $(this).find('input[type=password]'),
// 					'$toggleEnterVisible': $(this).find('.enter-visible')
// 				},
// 				hide = orion.hide,
// 				show = orion.show;

// 			function toStateFromView(view, model) {
// 				model.enterVisible = view.$toggleEnterVisible.prop('checked');
// 			}

// 			function syncPasswordsToVisibles(view) {
// 				view.$passwordElements.each(function () {
// 					var
// 						$passwordElement = $(this),
// 						$visiblePasswordElement = $passwordElement.data('sync-with');

// 					$visiblePasswordElement.val($passwordElement.val());
// 				});
// 			}

// 			function syncVisiblesToPasswords(view) {
// 				view.$visiblePasswordElements.each(function () {
// 					var
// 						$visiblePasswordElement = $(this),
// 						$passwordElement = $visiblePasswordElement.data('sync-with');

// 					$passwordElement.val($visiblePasswordElement.val());
// 				});
// 			}

// 			function updateViewFromState(view, model) {
// 				if (model.enterVisible) {
// 					syncPasswordsToVisibles(view);
// 					show(view.$visiblePasswordElements);
// 					hide(view.$passwordElements);
// 				} else {
// 					syncVisiblesToPasswords(view);
// 					hide(view.$visiblePasswordElements);
// 					show(view.$passwordElements);
// 				}
// 			}

// 			function handleClickToggleEnterVisible() {
// 				model.enterVisible = view.$toggleEnterVisible.prop('checked');
// 				updateViewFromState(view, model);
// 			}

// 			function handleInput() {
// 				if (model.enterVisible) {
// 					syncVisiblesToPasswords(view);
// 				} else {
// 					syncPasswordsToVisibles(view);
// 				}
// 			}

// 			function createVisiblePasswordElements(view) {
// 				view.$visiblePasswordElements = $();

// 				view.$passwordElements.each(function () {
// 					var
// 						$passwordElement = $(this),
// 						$visiblePasswordElement = $passwordElement.clone().removeAttr('name')
// 							.attr('type', 'text')
// 							.addClass('hidden')
// 							.data('sync-with', $passwordElement);

// 					$passwordElement.data('sync-with', $visiblePasswordElement);
// 					$visiblePasswordElement.insertAfter($passwordElement);

// 					view.$visiblePasswordElements = view.$visiblePasswordElements.add($visiblePasswordElement);
// 				});
// 			}

// 			function handleSubmit() {
// 				if (model.enterVisible) {
// 					syncVisiblesToPasswords(view);
// 				}
// 			}

// 			toStateFromView(view, model);
// 			createVisiblePasswordElements(view);

// 			view.$toggleEnterVisible.on('change', handleClickToggleEnterVisible);
// 			view.$form
// 				.on('submit', handleSubmit)
// 				.on('input', 'input[type=text], input[type=password]', handleInput);
// 		});

// });
